<template>
  <div>
    <v-dialog v-model="tahsilatdialog" persistent max-width="500px">
      <v-card color="grey lighten-2">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont"></v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" flat @click.native="tahsilatdialog=false">{{$t('Cancel')}}</v-btn>
            <v-btn id="bkaydet" color="blue darken-1" flat @click="tahsilatkaydet()">{{$t("save_button")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,

    methods: {
      deneme(){},

      open(title) {
        if (title == 'tahsilat') {
          this.dialogbaslik = this.$t('Add-Collection')
          this.kaydetbuton=true
          this.tahsilatguncellebuton=false
        }

        if (title == 'update') {
          this.dialogbaslik = 'Tahsilat Güncelle'
          this.tahsilatguncellebuton = true
          this.kaydetbuton=false

          var seciliitems = [{
            text: this.val.KarsiCari,
            id: this.val.KarsiCari
          }]
          this.statecaritahsilat = seciliitems
        }

        this.tahsilatdialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },

    },
    data() {
      return {
        dialogbaslik: '',
        resolve: null,
        kaydetbuton:false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {


    },
  }


  function beforeMount() {

  }


</script>